import React from 'react';

import {
  FaTruck,
  FaDonate,
  FaMoneyCheckAlt,
  FaGift,
  FaShapes,
  FaLaptopHouse,
} from 'react-icons/fa';
import { MdGroupWork } from 'react-icons/md';
import { IoMdPie } from 'react-icons/io';

export default {
  'Operadores Logísticos': {
    icon: <FaTruck size={30} />,
    link: '/configurations/thirdpartylogisticsproviders',
    perm: 'conf_t_p_l_p',
    backgroundColor: '#747474',
  },
  'Tipos de Abatimentos Fiscais': {
    icon: <FaDonate size={30} />,
    link: '/configurations/taxdeductiontypes',
    perm: 'conf_tax_deduction_types',
    backgroundColor: '#747474',
  },
  'Tipos de Custos de Eventos': {
    icon: <FaMoneyCheckAlt size={30} />,
    link: '/configurations/eventcosttypes',
    perm: 'conf_event_cost_types',
    backgroundColor: '#747474',
  },
  'Tipos de Brindes': {
    icon: <FaGift size={30} />,
    link: '/configurations/gifttypes',
    perm: 'conf_gift_types',
    backgroundColor: '#747474',
  },
  'Categorias de Registros de Lojas': {
    icon: <FaShapes size={30} />,
    link: '/configurations/storerelationshipcategories',
    perm: 'conf_s_r_categories',
    backgroundColor: '#747474',
  },
  'Tipos de Tópico de Registros de Lojas': {
    icon: <FaLaptopHouse size={30} />,
    link: '/configurations/storerelationshiptopictypes',
    perm: 'conf_s_r_topic_types',
    backgroundColor: '#747474',
  },
  'Grupos Políticas Comerciais': {
    icon: <MdGroupWork size={30} />,
    link: '/configurations/policygroups',
    perm: 'conf_policy_groups',
    backgroundColor: '#747474',
  },
  'Saldos Rebate - Trimestres': {
    icon: <IoMdPie size={30} />,
    link: '/configurations/rebatebalancequarters',
    perm: 'conf_rebate_bal_quarters',
    backgroundColor: '#747474',
  },
};
